import { useCookieState } from 'ahooks';

const useFilterDrawerPreference = (): {
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
} => {
    const [hide, setHide] = useCookieState('hideFilter');

    const handleDrawerToggle = () => {
        setHide(hide === 'true' ? 'false' : 'true');
    };

    return {
        filterDrawerOpen: hide === 'true' ? false : true,
        toggleFilterDrawer: handleDrawerToggle,
    };
};

export { useFilterDrawerPreference };
